/** @file Track index of the direction fix layer for a base track (tracks >= BASE_TRACKS are reserved). */
import { invariant } from '@pose2d/std/invariant';
import { BASE_TRACKS } from '../../state/baseTracks.data';

/** Built once: stepState and applyState call fixTrackOf every frame, so the message must not be built per call. */
const NOT_A_BASE_TRACK = `base track must be an integer in [0, ${BASE_TRACKS}); tracks ${BASE_TRACKS}+ hold fix layers`;

/** Track of the fix layer that belongs to base track `track`, which must be an integer in [0, BASE_TRACKS) (W2-12). */
export function fixTrackOf(track: number): number {
  invariant(Number.isInteger(track) && track >= 0 && track < BASE_TRACKS, NOT_A_BASE_TRACK);
  return BASE_TRACKS + track;
}
